import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgBustJuridicoCerto(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.122 27.747a3.265 3.265 0 0 1 3.265-3.266h48.98v65.307h-48.98a3.265 3.265 0 0 1-3.265-3.265V27.747Z"
        fill="#B3C0D0"
      />
      <path
        d="M11.387 27.747a3.265 3.265 0 0 1 3.265-3.266h45.715v58.776H14.652a3.265 3.265 0 0 1-3.265-3.265V27.747Z"
        fill="#F1F5F9"
      />
      <path
        d="M7.47 86.523V27.747a3.918 3.918 0 0 1 3.917-3.918h42.45a.652.652 0 1 1 0 1.305h-42.45a2.613 2.613 0 0 0-2.613 2.613v58.776a.652.652 0 1 1-1.305 0Z"
        fill="#B3C0D0"
      />
      <path
        d="M8.122 86.523a3.265 3.265 0 0 1 3.265-3.266h48.98v6.531h-48.98a3.265 3.265 0 0 1-3.265-3.265Z"
        fill="#CCD5E1"
      />
      <path
        d="M61.02 82.605v7.836H11.387a3.918 3.918 0 1 1 0-7.836H61.02ZM8.774 86.523a2.613 2.613 0 0 0 2.613 2.612h48.328V83.91H11.386a2.613 2.613 0 0 0-2.613 2.613Z"
        fill="#B3C0D0"
      />
      <path
        d="M35.55 57.135c-5.41 0-9.795-4.386-9.795-9.796 0-5.41 4.385-9.796 9.796-9.796v19.592Z"
        fill="#5BBDA0"
      />
      <path
        d="M35.55 57.135c5.41 0 9.797-4.386 9.797-9.796 0-5.41-4.386-9.796-9.797-9.796v-3.266c7.214 0 13.062 5.848 13.062 13.062 0 7.213-5.848 13.061-13.062 13.061v-3.265Z"
        fill="#5BBDA0"
      />
      <path
        d="M22.49 47.339c0 7.213 5.847 13.061 13.06 13.061v3.265c-9.016 0-16.326-7.31-16.326-16.326 0-9.017 7.31-16.327 16.327-16.327v3.265c-7.214 0-13.062 5.848-13.062 13.062Z"
        fill="#5BBDA0"
      />
      <path
        d="M11.496 40.481A4.028 4.028 0 1 0 7.47 44.51v1.741a5.768 5.768 0 1 1 5.768-5.769.87.87 0 1 1-1.74 0ZM11.496 53.543A4.028 4.028 0 1 0 7.47 57.57v1.741a5.768 5.768 0 1 1 5.768-5.768.87.87 0 1 1-1.74 0ZM11.496 66.604a4.028 4.028 0 1 0-4.027 4.028v1.74a5.768 5.768 0 1 1 5.768-5.768.87.87 0 1 1-1.74 0Z"
        fill="#0F172A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.407 68.882a1.633 1.633 0 0 0-.533 2.246c1.094 1.775 2.596 3.285 4.47 4.335a1.633 1.633 0 1 0 1.597-2.848c-1.351-.758-2.461-1.86-3.287-3.2a1.633 1.633 0 0 0-2.247-.533Z"
        fill="#A6DBCB"
      />
      <path
        d="M35.55 66.855v22.234c0 .796.54 1.49 1.31 1.687l24.6 6.293a1.742 1.742 0 0 0 2.172-1.687V68.287c0-.795-.539-1.49-1.31-1.687l-15.854-4.055a1.74 1.74 0 0 0-.932.019l-8.745 2.623c-.736.22-1.24.899-1.24 1.668Z"
        fill="#78B441"
      />
      <path
        d="M45.809 84.348a.871.871 0 0 1 1.06-.628l16.326 4.177a.87.87 0 1 1-.431 1.687l-16.327-4.177a.871.871 0 0 1-.628-1.06Z"
        fill="#42A486"
      />
      <path
        d="M37.51 66.267c0-.769.504-1.447 1.24-1.668l3.048-.914a1.741 1.741 0 0 1 2.242 1.668V85.88c0 .77-.504 1.447-1.24 1.668l-3.048.915a1.742 1.742 0 0 1-2.242-1.669V66.267Z"
        fill="#fff"
      />
      <path
        d="M37.51 87.874c0-.414.271-.78.668-.899l4.654-1.396a.938.938 0 1 1 .54 1.797l-4.654 1.397a.938.938 0 0 1-1.208-.899Z"
        fill="#B3C0D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.634 75.036a1.633 1.633 0 0 1 1.342-1.879c2.28-.38 4.72-.028 6.612 1.383a1.633 1.633 0 0 1-1.953 2.617c-1.006-.75-2.483-1.052-4.122-.779a1.633 1.633 0 0 1-1.879-1.342Z"
        fill="#A6DBCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.303 78.275a1.633 1.633 0 0 1 1.372-1.857c1.28-.192 2.355-.303 3.403-.192 1.088.116 2.04.459 3.121 1a1.633 1.633 0 0 1-1.46 2.92c-.878-.438-1.44-.612-2.007-.673-.605-.064-1.328-.012-2.572.174a1.633 1.633 0 0 1-1.857-1.372Z"
        fill="#A6DBCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.576 81.681a1.633 1.633 0 0 1 1.155-2c1.546-.413 3.6-.38 5.046.11a1.633 1.633 0 1 1-1.046 3.093c-.785-.265-2.178-.31-3.155-.048a1.633 1.633 0 0 1-2-1.154Z"
        fill="#A6DBCB"
      />
      <path
        d="M33.59 79.156c1.64-.44 3.805-.407 5.361.12a.544.544 0 0 1-.349 1.03c-1.335-.451-3.28-.487-4.73-.099a.544.544 0 1 1-.282-1.051Zm.004-3.276c1.287-.193 2.42-.314 3.542-.194 1.175.125 2.19.495 3.306 1.053a.545.545 0 0 1-.487.973c-1.047-.523-1.934-.838-2.935-.944-.975-.104-1.99-.002-3.264.189a.545.545 0 0 1-.162-1.077ZM73.428 12.073c-9.017 0-16.326 7.31-16.326 16.327v5.049c0 5.308-1.96 10.54-1.96 15.849 0 9.017 7.31 16.326 16.327 16.326 9.017 0 12.534-1.959 21.551-1.959 9.017 0 16.327-7.31 16.327-16.326 0-7.39-4.48-10.514-12.922-15.233-4.114-2.3-6.29-6.855-8.417-11.061-2.69-5.323-8.209-8.972-14.58-8.972Z"
        fill="#0F172A"
      />
      <path d="M70.816 38.196h6.53v7.837h-6.53v-7.837Z" fill="#80CCB5" />
      <path
        d="M77.673 37.87v8.489H70.49v-8.49h7.183Zm-6.53 7.836h5.877v-7.184h-5.878v7.184Z"
        fill="#0F172A"
      />
      <path
        d="M86.49 28.4v.653a3.265 3.265 0 1 1-1.81 5.984 13.055 13.055 0 0 1-11.252 6.424c-4.79 0-8.978-2.579-11.252-6.424a3.265 3.265 0 1 1-1.81-5.984V28.4c0-7.214 5.849-13.062 13.062-13.062 7.214 0 13.062 5.848 13.062 13.062Z"
        fill="#A6DBCB"
      />
      <path
        d="M58.428 27.616a27.837 27.837 0 0 0 15-12.092 27.837 27.837 0 0 0 15 12.092c-.407-7.931-6.967-14.237-15-14.237-8.033 0-14.593 6.306-15 14.237Z"
        fill="#0F172A"
      />
      <path
        d="m54.92 77.249 2.835 6.008c-3.123 5.127-5.044 9.151-7.01 13.946-.439 1.068-.277 2.302.496 3.16 10.04 11.152 28.457 11.152 38.497 0 .773-.858.935-2.092.496-3.16-1.966-4.795-3.887-8.819-7.01-13.946l-2.253-3.918 9.437-13.061 7.53-2.613c-1.966-11.319-12.502-20.198-25.1-18.716-15.44 1.817-24.55 18.24-17.918 32.3Z"
        fill="#F1F5F9"
      />
      <path
        d="M67.777 47.71a2.395 2.395 0 0 1 3.244.554l.97 1.295a.653.653 0 1 1-1.045.784l-.97-1.294a1.085 1.085 0 0 0-.34-.297c-.013.022-.024.046-.04.067-2.5 3.33-5.412 9.08-6.634 14.341a.653.653 0 0 1-1.272-.295c1.112-4.787 3.557-9.933 5.898-13.461l-1.634 1.09a.653.653 0 0 1-.725-1.087l2.548-1.697Z"
        fill="#B3C0D0"
      />
      <path
        d="M70.575 28.27a.872.872 0 0 1 1.474.927c-.187.298-.39.585-.606.863a2.394 2.394 0 0 0 3.4.05.87.87 0 0 1 1.218 1.245 4.136 4.136 0 0 1-5.796-.009c-.191.177-.387.35-.592.514a.87.87 0 1 1-1.087-1.362 8.907 8.907 0 0 0 1.99-2.228Zm3.997-5.875a2.503 2.503 0 1 1 2.503 4.336.87.87 0 1 1-.87-1.508.762.762 0 0 0-.763-1.32.87.87 0 1 1-.87-1.508Z"
        fill="#0F172A"
      />
      <path
        d="m64.373 85.216-7.271 15.991a26.74 26.74 0 0 1-5.892-5.125c1.812-4.315 3.668-8.102 6.545-12.825L54.92 77.25c-4.905-10.4-1.199-22.09 7.31-28.209-2.508 12.752-1.84 23.864 2.143 36.176Z"
        fill="#78B441"
      />
      <path
        d="M53.314 62.408a.654.654 0 0 1 .51.77c-.907 4.445-.458 9.243 1.687 13.792l2.434 5.16c.344.73.296 1.58-.114 2.266-2.587 4.325-4.322 7.896-6.02 11.939a.653.653 0 0 1-1.203-.506c1.718-4.092 3.48-7.719 6.101-12.104.19-.318.21-.708.054-1.037l-2.434-5.16c-2.27-4.813-2.747-9.9-1.785-14.611a.653.653 0 0 1 .77-.51Z"
        fill="#0F172A"
      />
      <path
        d="m59.06 76.727 7.184 28.04c8.372 1.463 17.28-1.433 23.525-8.685-1.812-4.315-3.668-8.102-6.545-12.825l-2.253-3.918 9.437-13.061 7.53-2.613c-1.515-8.724-8.122-16-16.84-18.197-7.703 5.073-18.393 14.15-22.037 31.259Z"
        fill="#78B441"
      />
      <path
        d="M60.661 68.983a.653.653 0 1 1 1.22.467 49.49 49.49 0 0 0-2.096 7.019 1.06 1.06 0 0 0 .01.49l3.244 12.667a.653.653 0 1 1-1.265.324L58.53 77.284a2.368 2.368 0 0 1-.019-1.098 50.787 50.787 0 0 1 2.151-7.204Z"
        fill="#0F172A"
      />
      <path
        d="m95.002 55.828-13.084 6.205 13.4 28.408c1.387 2.939 12.07-.398 11.377-3.592-2.229-10.268-5.9-22.568-11.693-31.02Z"
        fill="#78B441"
      />
      <path
        d="M81.64 61.443a.653.653 0 0 1 .869.31l7.394 15.675a.653.653 0 0 1-1.183.557L81.329 62.31a.652.652 0 0 1 .311-.868Zm-4.102-.198a.652.652 0 0 1 .923 0l1.96 1.959a.654.654 0 0 1-.924.923l-1.959-1.96a.652.652 0 0 1 0-.922Z"
        fill="#0F172A"
      />
      <path
        d="M95.318 90.441c1.386 2.939 12.07-.398 11.376-3.592-.39-1.798-.824-3.66-1.307-5.55-4.121-1.481-10.716 1.48-12.225 4.57l2.156 4.572Z"
        fill="#B3C0D0"
      />
      <path
        d="M108.041 93.706a173.867 173.867 0 0 0-2.286-10.934l-6.701 1.465 3.1 9.096c-2.006 1.675-5.215 4.47-5.215 7.557 0 3.265 3.265 5.878 5.224 5.878 2.612 0 7.837-1.959 7.837-5.225 0-3.406-1.197-6.53-1.959-7.837Z"
        fill="#A6DBCB"
      />
      <path
        d="m93.162 85.87 2.156 4.571c-1.232-2.612 10.764-6.416 11.377-3.592-.391-1.798-.825-3.66-1.308-5.55-4.121-1.481-10.716 1.48-12.225 4.57Z"
        fill="#F1F5F9"
      />
      <path d="M63.632 77.053a.98.98 0 1 1-1.959 0 .98.98 0 0 1 1.96 0Z" fill="#0F172A" />
    </svg>
  )
}
export default wrapIllustration(SvgBustJuridicoCerto)
